export default __webpack_public_path__ + "static/IN-8015HD-vs-IN-6014HD_night-e17daa6b1854b792de5c31de59b25143.webp";